/**
 * 受付一覧
 */
import { mapGetters } from 'vuex'
import flowMixin from '@/mixins/flowMixins'
import filter from '@/rahmen/utils/filters'
import validators from '@/rahmen/validators'

import date from '@/ddv2.library/date'
import header from '@/ddv2.library/header'
import modals from '@/ddv2.library/modals'

import DdSearchList from '@/components/DdSearchList'
import DdCodeTextBox from '../../components/DdCodeTextBox.vue'
import DdDateRangeBox from '@/components/DdDateRangeBox'
import DdRadioGroup from '@/components/DdRadioGroup'
import DdRadioButton from '@/components/DdRadioButton'
import DdTextBox from '../../components/DdTextBox.vue'

export default {
  name: 'RcoJuchuList',
  mixins: [flowMixin],
  components: {
    DdSearchList,
    DdCodeTextBox,
    DdDateRangeBox,
    DdRadioGroup,
    DdRadioButton,
    DdTextBox
  },
  data: () => ({
    // 一覧制御用
    selected: [],
    itemsPerPage: 100,
    page: 1,
    isConditionHide: false,
    isCsvDownloader: false,
    isPdfDownloader: false,

    rows: [],
    conditions: {
      juchuEigyoshoCd: '',
      juchuStartYmdString: '',
      juchuEndYmdString: '',
      nyuryokuTantoshaCd: '',
      sagyoEigyoshoCd: '',
      tokuisakiCd: '',
      sagyoYoteiStartYmdString: '',
      sagyoYoteiEndYmdString: '',
      chumonNo: '',
      sagyoNo: '',
      hacchuNo: '',
      ninushiCd: '',
      hatsuchiCd: '',
      oroshisakiCd: '',
      chakuchiCd: '',
      juchuStatus: '99',
      seikyuStatus: '99'
    },
    dummys: {
      ymdString: '',
      hmsString: '',
      biko: ''
    },
    mstEigyoshoHeaders: header.mstEigyoshoHeaders,
    mstJininHeaders: header.mstJininHeaders,
    mstTorihikisakiHeaders: header.mstTorihikisakiHeaders,
    mstHacchakuchiHeaders: header.mstHacchakuchiHeaders,
    modeKengen: 0
  }),
  computed: {
    ...mapGetters({
      viewTitle: 'system/viewTitle',
      helpUseFlg: 'DDMasters/helpUseFlg',
      eigyoshoList: 'DDMasters/mstEigyosho',
      eigyoshoJininList: 'DDMasters/vwCMstEigyoshoJininList',
      torihikisakiList: 'DDMasters/mstTorihikisaki',
      hacchakuchiList: 'DDMasters/mstHacchakuchi',
      userEigyoshoCd: 'users/eigyoshoCd',
      eigyoshoLockFlg: 'users/anotherEigyoshoCtrlFlg'
    }),
    eigyoshoReadOnly () {
      const self = this
      return !self.eigyoshoLockFlg
    },
    filteredRows () {
      console.log('filter', this.rows)
      return this.rows.map((elem) => {
        elem.juchuYmd = filter.dateFormatter(elem.juchuYmd)
        elem.juchuEigyoshoDisp = elem.juchuEigyoshoCd ? elem.juchuEigyoshoCd + ' : ' + elem.juchuEigyoshoNm : ''
        elem.sagyoEigyoshoDisp = elem.sagyoEigyoshoCd ? elem.sagyoEigyoshoCd + ' : ' + elem.sagyoEigyoshoNm : ''
        elem.tokuisakiDisp = elem.tokuisakiCd ? elem.tokuisakiCd + ' : ' + elem.tokuisakiNm : ''
        elem.seikyuTomeFlgDisp = elem.seikyuTomeFlg ? '請求対象外' : '請求対象'
        elem.ikkatsuSeikyuFlgDisp = elem.ikkatsuSeikyuFlg ? '一括請求' : '個別請求'
        elem.seikyuYoteiYmd = elem.seikyuYoteiYmd ? filter.dateFormatter(elem.seikyuYoteiYmd) : ''
        elem.unchinKakuteiFlgDisp = elem.unchinKakuteiFlg ? '確定' : '未確定'
        elem.seikyuZumiFlgDisp = elem.seikyuZumiFlg ? '請求済み' : '未請求'
        elem.seikyuKingaku = filter.numericFormatter(elem.seikyuKingaku)
        elem.juchuMeisaiKingaku = filter.numericFormatter(elem.juchuMeisaiKingaku)
        elem.sagyoYoteiYmd = elem.sagyoYoteiYmd ? filter.dateFormatter(elem.sagyoYoteiYmd) : ''
        elem.ninushiDisp = elem.ninushiCd ? elem.ninushiCd + ' : ' + elem.ninushiNm : ''
        elem.hatsuchiDisp = elem.hatsuchiCd ? elem.hatsuchiCd + ' : ' + elem.hatsuchiNm : ''
        elem.hatsuchiYmd = elem.hatsuchiYmd ? filter.dateFormatter(elem.hatsuchiYmd) : ''
        elem.hatsuchiHms = elem.hatsuchiHms ? (elem.hatsuchiHms).slice(0, 5) : ''
        // elem.oroshisakiDisp = elem.oroshisakiCd ? elem.oroshisakiCd + ' : '  + elem.oroshisakiNm : ''
        elem.chakuchiDisp = elem.chakuchiCd ? elem.chakuchiCd + ' : ' + elem.chakuchiNm : ''
        elem.chakuchiYmd = elem.chakuchiYmd ? filter.dateFormatter(elem.chakuchiYmd) : ''
        elem.chakuchiHms = elem.chakuchiHms ? (elem.chakuchiHms).slice(0, 5) : ''
        elem.yoteiSagyoJikan = elem.yoteiSagyoJikan ? filter.minToTimeFormatter(elem.yoteiSagyoJikan) : ''
        elem.warimashiTaishoJikan = elem.warimashiTaishoJikan ? filter.minToTimeFormatter(elem.warimashiTaishoJikan) : ''
        elem.warimashiJikanTanka = elem.warimashiJikanTanka ? filter.numericFormatter(elem.warimashiJikanTanka) : ''
        elem.yoteiSokoKyori = elem.yoteiSokoKyori ? filter.numericFormatter(elem.yoteiSokoKyori) : ''
        elem.warimashiTaishoKyori = elem.warimashiTaishoKyori ? filter.numericFormatter(elem.warimashiTaishoKyori) : ''
        elem.warimashiKyoriTanka = elem.warimashiKyoriTanka ? filter.numericFormatter(elem.warimashiKyoriTanka) : ''
        elem.juchuInsDate = filter.dateFormatter(elem.juchuInsDate)
        elem.juchuInsUserDisp = elem.juchuInsUserCd ? elem.juchuInsUserCd + ' : ' + elem.juchuInsUserNm : ''
        elem.juchuUpdDate = filter.dateFormatter(elem.juchuUpdDate)
        elem.juchuUpdUserDisp = elem.juchuUpdUserCd ? elem.juchuUpdUserCd + ' : ' + elem.juchuUpdUserNm : ''

        return elem
      })
    },
    filteredEigyoshoList () {
      const target = filter.dateFormatter(new Date())
      // const self = this
      return this.eigyoshoList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      }).filter(function (elem) {
        return elem.tekiyoStartYmdDisp <= target && elem.tekiyoEndYmdDisp >= target && elem.eigyoshoKbn === '01'
        // 他営業所捜査フラグを考慮する場合は↓を適用
        // return elem.tekiyoStartYmdDisp <= target && elem.tekiyoEndYmdDisp >= target && elem.eigyoshoKbn === '01' && (self.anotherEigyoshoCtrlFlg === true || (self.anotherEigyoshoCtrlFlg === false && elem.eigyoshoCd === self.usersEigyoshoCd))
      })
    },
    filteredNyuryokuTantoshaList () {
      const self = this
      const target = filter.dateFormatter(new Date())
      // const self = this
      return this.eigyoshoJininList.map((elem) => {
        elem.jomuFlg = elem.jomuFlg ? '乗務員' : ''
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      }).filter(function (elem) {
        return elem.tekiyoStartYmdDisp <= target && elem.tekiyoEndYmdDisp >= target && elem.eigyoshoKbn === '01' &&
        (self.eigyoshoLockFlg || elem.eigyoshoCd === self.userEigyoshoCd)
        // 他営業所捜査フラグを考慮する場合は↓を適用
        // return elem.tekiyoStartYmdDisp <= target && elem.tekiyoEndYmdDisp >= target && elem.eigyoshoKbn === '01' && (self.anotherEigyoshoCtrlFlg === true || (self.anotherEigyoshoCtrlFlg === false && elem.eigyoshoCd === self.usersEigyoshoCd))
      })
    },
    filteredTokuisakiList () {
      const target = filter.dateFormatter(new Date())
      return this.torihikisakiList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      }).filter(function (elem) {
        return elem.tekiyoStartYmdDisp <= target && elem.tekiyoEndYmdDisp >= target && elem.tokuisakiFlg === true
      })
    },
    filteredMstHacchakuchiList () {
      const target = filter.dateFormatter(new Date())
      return this.hacchakuchiList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      }).filter(function (elem) {
        return elem.tekiyoStartYmdDisp <= target && elem.tekiyoEndYmdDisp >= target
      })
    },
    isCsvButtonDisabled () {
      return this.rows.length === 0
    },
    deleteButtonDisp () {
      if (this.modeKengen === 2) {
        return true
      } else {
        return false
      }
    },
    createButtonDisp () {
      if (this.modeKengen === 0) {
        return false
      }
      return true
    }
  },
  created () {
  },
  mounted () {
    this.initialize()
  },
  beforeRouteUpdate (to, from, next) {
    this.$refs.initialize()
    next()
  },
  methods: {
    getCloneTargetMethod: function () {
      return {
        rows: this.rows,
        conditions: this.conditions,
        searchText: this.searchText
      }
    },
    initialize () {
      console.log('initialize')
      const self = this
      const opt = {
        loadMasters: ['msteigyosho', 'vwcmsteigyoshojininlist', 'msttorihikisaki', 'msthacchakuchi'],
        defineHeaderPromise: () => {
          return new Promise(resolve => {
            console.log('RcoJuchuList.defineHeaderPromise')
            this.headers = [
              { text: '編集', value: 'actions', sortable: false, width: '20px' },
              { text: '作業進捗', value: 'sagyoStatusNm' },
              { text: '受注番号', value: 'juchuNo' },
              { text: '受注日', value: 'juchuYmd' },
              { text: '受注営業所', value: 'juchuEigyoshoDisp' },
              { text: '作業予定日', value: 'sagyoYoteiYmd' },
              { text: '作業営業所', value: 'sagyoEigyoshoDisp' },
              { text: '客先注文番号', value: 'chumonNo' },
              { text: '得意先', value: 'tokuisakiDisp' },
              { text: '請求止', value: 'seikyuTomeFlgDisp', align: 'center' },
              { text: '請求区分', value: 'ikkatsuSeikyuFlgDisp', align: 'center' },
              { text: '請求予定日', value: 'seikyuYoteiYmd', align: 'center' },
              { text: '運賃確定状況', value: 'unchinKakuteiFlgDisp', align: 'center' },
              { text: '請求状況', value: 'seikyuZumiFlgDisp', align: 'center' },
              { text: '請求基本金額', value: 'seikyuKingaku', align: 'right', filterable: false },
              { text: '受注契約番号', value: 'juchuKeiyakuNo' },
              { text: '受注明細番号', value: 'juchuMeisaiNo' },
              { text: '請求明細金額', value: 'juchuMeisaiKingaku', align: 'right', filterable: false },
              // { text: '荷主', value: 'ninushiDisp' },
              { text: '発地', value: 'hatsuchiDisp' },
              { text: '発日付', value: 'hatsuchiYmd', align: 'center' },
              { text: '発時刻', value: 'hatsuchiHms', align: 'center' },
              { text: '発時刻備考', value: 'hatsuchiHmsBiko' },
              // { text: '卸先', value: 'oroshisakiDisp' },
              { text: '着地', value: 'chakuchiDisp' },
              { text: '着日付', value: 'chakuchiYmd', align: 'center' },
              { text: '着時刻', value: 'chakuchiHms', align: 'center' },
              { text: '着時刻備考', value: 'chakuchiHmsBiko' },
              { text: '予定作業時間', value: 'yoteiSagyoJikan', align: 'center' },
              { text: '割増対象時間', value: 'warimashiTaishoJikan', align: 'center' },
              { text: '割増時間単価', value: 'warimashiJikanTanka', align: 'right' },
              { text: '予定作業距離', value: 'yoteiSokoKyori', align: 'right' },
              { text: '割増対象距離', value: 'warimashiTaishoKyori', align: 'right' },
              { text: '割増距離単価', value: 'warimashiKyoriTanka', align: 'right' },
              { text: '登録日', value: 'juchuInsDate' },
              { text: '登録者', value: 'juchuInsUserDisp' },
              { text: '更新日', value: 'juchuUpdDate' },
              { text: '更新者', value: 'juchuUpdUserDisp' }
            ]
            resolve()
          })
        },
        initializeInputPromise: function () {
          return new Promise((resolve) => {
            const d = new Date()
            self.conditions = {
              juchuEigyoshoCd: self.userEigyoshoCd,
              juchuStartYmdString: date.getFirstDate(d.getFullYear(), d.getMonth() + 1),
              juchuEndYmdString: date.getLastDate(d.getFullYear(), d.getMonth() + 1),
              nyuryokuTantoshaCd: '',
              sagyoEigyoshoCd: '',
              tokuisakiCd: '',
              sagyoYoteiStartYmdString: '',
              sagyoYoteiEndYmdString: '',
              chumonNo: '',
              sagyoNo: '',
              hacchuNo: '',
              ninushiCd: '',
              hatsuchiCd: '',
              oroshisakiCd: '',
              chakuchiCd: '',
              juchuStatus: '99',
              seikyuStatus: '99'
            }
            resolve()
          })
        },
        savedInputRestorePromise: (c) => {
          console.log('RcoJuchuList.savedInputRestorePromise', c)
          // ユーザ保存項目の復元
          self.conditions = { ...self.conditions, ...c }
          return new Promise(resolve => {
            this.loadFromCache()
              .then((c) => {
                console.log('RcoJuchuList.savedInputRestorePromise', c)
                resolve()
              })
          })
        },
        researchPromise: (c) => {
          console.log('RcoJuchuList.researchPromise', c)
          return new Promise(resolve => {
            self.conditions = c.cache.value ? c.cache.value.conditions || {} : self.conditions
            self.onSearchButtonClick()
            resolve()
          })
        },
        restoreViewPromise: (c) => {
          console.log('RcoJuchuList.restoreViewPromise', c)
          return new Promise(resolve => {
            self.conditions = c.cache.value ? c.cache.value.conditions || {} : self.conditions
            self.searchText = c.cache.value ? c.cache.value.searchText || '' : self.searchText
            self.rows = c.cache.value ? c.cache.value.rows || [] : self.rows
            resolve()
          })
        },
        settingButtonStatePromise: (kengen) => {
          console.log('RcoJuchuList.settingButtonStatePromise', kengen)
          return new Promise(resolve => {
            console.log('settingButtonStatePromise', kengen)
            if (kengen.kengenKbn === '10') {
              // 読取モード
              self.modeKengen = 0
            } else if (kengen.kengenKbn === '20') {
              // 削除不可モード
              self.modeKengen = 1
            } else {
              // フルアクセス
              self.modeKengen = 2
            }

            this.$nextTick(() => {
              document.getElementById('heavy-element').style.display = ''
            })

            resolve()
          })
        }
      }
      this.initializeForViewer(opt)
    },
    onSearchButtonClick: function (e) {
      // 選択状態初期化
      this.selected = []
      this.page = 1

      const self = this
      const opt = {
        searchRequestPromise: function () {
          return new Promise(resolve => {
            self.HttpClient.post('/api/v1/VwCD2rcod0010/search', self.conditions)
              .then((data) => {
                resolve(data)
              })
          })
        },
        searchResultMethod: function (data) {
          self.rows = data.payload

          const cache = {
            rows: self.rows,
            conditions: self.conditions,
            searchText: self.searchText
          }
          self.saveToChache(cache)
            .then(() => {
            })
        },
        getSavedInputMethod: function () {
          return {
            juchuStatus: self.conditions.juchuStatus,
            seikyuStatus: self.conditions.seikyuStatus
          }
        }
      }
      this.search(opt)
    },
    onClearButtonClick: function (e) {
      this.Effects.loadStart()
      this.clear()
    },
    clear: function () {
      const self = this
      const opt = {
        clearInputsPromise: () => {
          return new Promise(resolve => {
            console.log('RcoJuchuList.clearInputsPromise')
            const d = new Date()
            const x = {
              juchuEigyoshoCd: self.userEigyoshoCd,
              juchuStartYmdString: date.getFirstDate(d.getFullYear(), d.getMonth() + 1),
              juchuEndYmdString: date.getLastDate(d.getFullYear(), d.getMonth() + 1),
              nyuryokuTantoshaCd: '',
              sagyoEigyoshoCd: '',
              tokuisakiCd: '',
              sagyoYoteiStartYmdString: '',
              sagyoYoteiEndYmdString: '',
              chumonNo: '',
              sagyoNo: '',
              hacchuNo: '',
              ninushiCd: '',
              hatsuchiCd: '',
              oroshisakiCd: '',
              chakuchiCd: '',
              juchuStatus: '99',
              seikyuStatus: '99'
            }
            self.conditions = x
            self.searchText = ''
            self.rows = []
            self.selected = []
            self.page = 1
            resolve()
          })
        }
      }
      this.clearInputs(opt)
    },
    onRowDoubleClick: function (e, f) {
      console.log(e, f)
      this.Effects.loadStart()
      this.transition(0, { id: f.item.id })
    },
    onRowEditButtonClick: function (item) {
      // 画面遷移
      this.Effects.loadStart()
      this.transition(0, { id: item.id })
    },
    onDeleteButtonClick: function (e) {
      var isDelete = true
      const self = this
      // 削除可能チェック
      for (const r of this.selected) {
        if (r.sagyoStatus !== '02' || r.seikyuZumiFlg) {
          isDelete = false
        }
      }

      // 削除処理実行
      if (isDelete) {
        const p = modals.showConfirm
        p('COMQ0003').then((ok) => {
          if (ok === false || ok === undefined) { return }

          this.Effects.loadStart()

          function deletePromise () {
            return new Promise(function (resolve) {
              var deleteTargetId = []
              self.selected.forEach((x) => {
                deleteTargetId.push(x.id)
              })
              self.HttpClient.delete(`/api/v1/TrJuchuKihon/MultipleDeleteWithChildren?id=${deleteTargetId.join(',')}`).then((data) => {
                resolve(data)
              })
            })
          }
          deletePromise().then(() => {
            console.log('complatePromise')
            self.Effects.loadComplete()
            modals.showSuccess('対象を削除しました。')
            // 再検索
            this.onSearchButtonClick()
          })
        })
      } else {
        modals.showError('計画済・作業完了・実績確認済み・請求済みの受注は削除できません。<br>対象を見直してください。')
      }
    },
    onCreateButtonClick: function (e) {
      console.log(e)
      this.Effects.loadStart()
      this.transition(0, { id: 0 })
    },
    searchValidate: function () {
      if (!this.conditions.juchuEigyoshoCd && !this.conditions.juchuStartYmdString && !this.conditions.juchuEndYmdString && !this.conditions.nyuryokuTantoshaCd && !this.conditions.sagyoEigyoshoCd && !this.conditions.tokuisakiCd && !this.conditions.sagyoYoteiStartYmdString && !this.conditions.sagyoYoteiEndYmdString && !this.conditions.chumonNo && !this.conditions.sagyoNo && !this.conditions.hacchuNo && !this.conditions.ninushiCd && !this.conditions.hatsuchiCd && !this.conditions.oroshisakiCd && !this.conditions.chakuchiCd && this.conditions.juchuStatus === '99' && this.conditions.seikyuStatus === '99') {
        this.setInvalidSummaryMessage('COME0026')
        return false
      }
      if (this.conditions.juchuStartYmdString && this.conditions.juchuEndYmdString) {
        const msg1 = validators.compareDate(this.conditions.juchuStartYmdString, this.conditions.juchuEndYmdString)
        if (msg1 !== undefined) {
          this.$refs.juchuStartYmdString[this.Ctrls.SET_INVALID_METHOD](msg1)
          this.$refs.juchuEndYmdString[this.Ctrls.SET_INVALID_METHOD](msg1)
          this.setInvalidSummaryMessage('COME0014')
          return false
        }
      }
      if (this.conditions.sagyoYoteiStartYmdString && this.conditions.sagyoYoteiEndYmdString) {
        const msg1 = validators.compareDate(this.conditions.sagyoYoteiStartYmdString, this.conditions.sagyoYoteiEndYmdString)
        if (msg1 !== undefined) {
          this.$refs.sagyoYoteiStartYmdString[this.Ctrls.SET_INVALID_METHOD](msg1)
          this.$refs.sagyoYoteiEndYmdString[this.Ctrls.SET_INVALID_METHOD](msg1)
          this.setInvalidSummaryMessage('COME0014')
          return false
        }
      }
      return true
    }
  }
}
